<template>
  <div class="x_box A4">
    <div class="x_body">
      <div class="text-center font-m">វិក្កយបត្រ</div>
      <div class="text-center">INVOICE</div>
      <br>
      <div class="row">
        <div class="col-sm-6">
          <table class="table-print">
            <tbody>
              <tr>
                <td>ឈ្មោះអ្នកផ្គត់ផ្គង់/Vendor</td>
                <td style="width: 15px;">:</td>
                <td>{{invoice.VendorName}}</td>
              </tr>
              <tr>
                <td>លេខទូរស័ព្ទ/Phone</td>
                <td style="width: 15px;">:</td>
                <td>{{invoice.Contact}}</td>
              </tr>
              <tr>
                <td>អាស័យដ្ឋាន/Address</td>
                <td>:</td>
                <td>{{vendor.Address}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-sm-6">
          <table class="table-print" align="right">
            <tbody>
              <tr>
                <td class="text-right">លេខរៀងវិក្កយបត្រ / Invoice No</td>
                <td style="width: 15px;">:</td>
                <td>{{invoice.Num}}</td>
              </tr>
              <tr>
                <td class="text-right">កាលបរិច្ឆេទចេញវិក្កយបត្រ / Invoice Date	</td>
                <td>:</td>
                <td>{{$format(invoice.Date, 'DD/MM/YYYY')}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <br/>
      <div class="row">
        <div class="col-sm-12">
          <table class="table table-bordered table-sm">
            <thead>
              <tr>
                <th class="text-center" style="width: 50px;">ល.រ</th>
                <th>មុខទំនិញ</th>
                <th class="text-center" style="width: 100px;">ចំនួន</th>
                <th class="text-center" style="width: 100px;">ខ្នាត</th>
                <th class="text-right" style="width: 100px;">តម្លៃ</th>          
                <th class="text-right" style="width: 100px;">សរុប</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(ret,index) in lines" :key="ret.Id">
                <td class="text-center">{{index+1}}</td>
                <td>{{ret.ItemName}}</td>
                <td class="text-center">{{ret.Quantity}}</td>
                 <td class="text-center">{{ret.UomName}}</td>
                <td class="text-right">{{ret.Price}}</td>         
                <td class="text-right">{{$money(ret.SubTotal)}}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="5" class="text-right">{{$t('grand_total')}}</td>
                <td class="text-right">{{$money(invoice.PaidAmount)}}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
    <div class="print-footer">
        <b>ល័ក្ខខ័ណ្ឌ</b>
      <p class="text-right">{{$format(invoice.Date, 'ថ្ងៃទី DD ខែ MM ឆ្នាំ YYYY')}}</p>
      <div style="display: flex; justify-content: space-between;">
        <div style="padding: 0 25px;">អ្នកទិញ Buyer</div>
        <div style="padding: 0 25px;">អ្នកលក់ Seller</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: function() {
    return {
      invoice: {},
      lines: [],
      vendor: {}
    };
  },
  created: function() {
    let id = this.$route.params.id;
    if (id !== undefined && id !== null && id !== "") {
      let loading = this.$loading.show();
      this.$api()
        .post('po/invoice/find', { Id: id })
        .then(res => {
          var data = res.data.Data;
          this.invoice = data.POInvoice;
          this.lines = data.POInvoiceLines;
          this.vendor = res.data.Json.Vendor;
        })
        .finally(function() {
          loading.hide();
        });
    }
  }
};
</script>
<style scoped>
  *{
    font-size: 12pt;
  }
  .table-bordered th, .table-bordered td {
    border: 1px solid black;
  }
  @media print{
    .table-bordered th, .table-bordered td {
      border: 1px solid black !important;
    }
  }
  .print-footer{
    padding: 15px 50px;
  }
</style>